import styled from 'styled-components';

export const Container = styled.div`
  .label-modal {
    display: inline-block;
    position: relative;
    height: 100px;
    width: 100%;
  }

  .input-box {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #edfaff;
    border: 3px dotted #2788d0;
    border-radius: 10px;
  }

  .form-group-color {
    color: #2681d5;
    position: relative;
    height: 100px;
  }

  .input-file {
    position: absolute;
    left: 0;
    opacity: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    cursor: pointer;
  }

  .modal-body {
    position: relative;
    flex: 1 1 auto;
    padding: 1rem;
  }

  .card-file {
    background: #DADFE3;
    color: #000000;
  }

  .card-file-error {
    background: #FEE3E5;
    color #E60000;
  }

  .card-file-loading {
    background: #DADFE3;
    color: ${(props) => props.theme.$gray500};
  }

  .progress {
    width: 20%;
    height: 4px;
  }

  .alert-icon {
    font-size: 20px;
  }
}
`;
